import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Button } from '..';
import { Portal } from '../root-layout/Portal';
import { useDialog } from './useDialog';
const ConfirmModalDialog = styled.dialog `
  background-color: transparent;

  ::backdrop {
    background-color: rgba(113, 113, 122, 0.75);
  }
`;
const ConfirmModalContents = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
  border-width: 1px;
  border-color: transparent;
  border-radius: 0.5rem;
  box-shadow: 0 0 0 0, 0 0px 16px rgba(0, 0, 0, 0.3);
  border-top: 10px solid ${({ headerColor }) => headerColor};
`;
const ConfirmModalChildrenRoot = styled.div `
  color: ${({ headerColor }) => headerColor};
  display: flex;
  flex: 1 1 0%;
`;
const ConfirmModalFooter = styled.div `
  border-top: 2px solid rgb(247, 247, 247);
  padding: 10px 20px 10px 20px;
  display: flex;
  flex-direction: row-reverse;
  gap: 10px;
`;
export function ConfirmModal(props) {
    const { isOpen, saveText = 'Save', cancelText = 'Cancel', headerColor, maxWidth, onRequestClose, onCancel = onRequestClose, onConfirm, requestCloseOnBackdrop = true, requestCloseOnEsc = true, children, } = props;
    const { ref, onClick } = useDialog({
        isOpen,
        requestCloseOnEsc,
        requestCloseOnBackdrop,
        onRequestClose,
    });
    if (!isOpen) {
        return null;
    }
    return (_jsx(Portal, { children: _jsx(ConfirmModalDialog, { ref: ref, onClick: onClick, children: _jsxs(ConfirmModalContents, { headerColor: headerColor, style: { maxWidth }, children: [_jsx(ConfirmModalChildrenRoot, { headerColor: headerColor, children: children }), _jsxs(ConfirmModalFooter, { children: [_jsx(Button, { onClick: onConfirm, backgroundColor: {
                                    basic: 'hsla(243deg, 75%, 58%, 1)',
                                    hover: 'hsla(245deg, 58%, 50%, 1)',
                                }, color: { basic: 'white' }, children: saveText }), _jsx(Button, { onClick: onCancel, backgroundColor: {
                                    basic: 'hsla(0deg, 72%, 50%, 1)',
                                    hover: 'hsla(0deg, 73%, 42%, 1)',
                                }, color: { basic: 'white' }, children: cancelText })] })] }) }) }));
}
//# sourceMappingURL=ConfirmModal.js.map